export default { sha: 'f9e60a2973e6b137249e839d32a26edaf0231540', buildNumber: 'undefined' }
